import { render, staticRenderFns } from "./sidebarBanner.vue?vue&type=template&id=7a010656&scoped=true&"
import script from "./sidebarBanner.vue?vue&type=script&lang=js&"
export * from "./sidebarBanner.vue?vue&type=script&lang=js&"
import style0 from "./sidebarBanner.vue?vue&type=style&index=0&id=7a010656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a010656",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a010656')) {
      api.createRecord('7a010656', component.options)
    } else {
      api.reload('7a010656', component.options)
    }
    module.hot.accept("./sidebarBanner.vue?vue&type=template&id=7a010656&scoped=true&", function () {
      api.rerender('7a010656', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/sidebarBanner.vue"
export default component.exports